/* tcb.js — comportamento das réplicas de apps no espelho DOGSHOOD (o resto é o JS do Dawn e os scripts c-* da referência).
   Glo Color Swatch: o app monta o seletor no navegador; aqui o seletor já vem em Liquid e este módulo liga o clique
   ao seletor do Dawn (escondido), que faz a troca de variante pela Section Rendering API como na referência. */
(function () {
  'use strict';

  function globoSync(root) {
    root.querySelectorAll('.globo-swatch-product-detail .swatch--gl').forEach(function (sw) {
      var i = +sw.dataset.optionIndex;
      var lab = sw.querySelector('.name-variant');
      var cur = sw.querySelector('input:checked');
      if (lab && cur) lab.innerHTML = '<span>: </span>' + cur.value;
      (void i);
    });
  }

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.globo-swatch-product-detail input[type=radio]')) return;
    var sw = inp.closest('.swatch--gl');
    var info = inp.closest('product-info') || document;
    var vs = info.querySelector('variant-selects');
    if (!sw || !vs) return;
    var fs = vs.querySelectorAll('fieldset')[+sw.dataset.optionIndex];
    if (!fs) return;
    var target = Array.prototype.find.call(fs.querySelectorAll('input[type=radio]'), function (x) { return x.value === inp.value; });
    if (!target) return;
    globoSync(sw);
    if (target.checked) return;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // depois que o Dawn busca a seção da nova variante: o seletor do app volta já com a variante escolhida
  function onVariant() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var html = ev && ev.data && ev.data.html;
      if (!html) return;
      var sid = ev.data.sectionId;
      var fresh = html.querySelector('.globo-swatch-product-detail');
      var root = sid ? document.querySelector('[data-section="' + sid + '"]') || document : document;
      var cur = (root.querySelector ? root : document).querySelector('.globo-swatch-product-detail');
      if (fresh && cur) cur.replaceWith(fresh);
      // a guia de tamanhos fica dentro da legenda do tamanho (o script da seção a move uma vez): devolver ao novo seletor
      var opener = document.querySelector('modal-opener[data-modal^="#DtSizeGuideModal"]');
      var legend = Array.prototype.find.call(document.querySelectorAll('.globo-swatch-product-detail legend.name-option'), function (l) { return /^size\b/i.test(l.textContent.trim()); });
      if (opener && legend && !legend.contains(opener)) {
        legend.classList.add('dt-has-size-guide');
        legend.setAttribute('style', 'display: flex !important; align-items: center !important; width: 100% !important; gap: 6px !important;');
        legend.appendChild(opener);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onVariant); else onVariant();
})();

/* Loox: documento renderizado da referência como srcdoc (1440 / 390), altura pelo conteúdo como o app */
(function () {
  'use strict';
  function mobile() { return document.documentElement.clientWidth < 750; }
  function mount() {
    document.querySelectorAll('[data-tcb-loox-frame]').forEach(function (w) {
      if (w.querySelector('iframe')) return;
      var src = (mobile() && w.querySelector('script.tcb-loox-doc-m')) || w.querySelector('script.tcb-loox-doc');
      if (!src) return;
      var f = document.createElement('iframe');
      var attrs = {};
      try { attrs = JSON.parse(w.getAttribute('data-tcb-loox-attrs') || '{}'); } catch (e) {}
      Object.keys(attrs).forEach(function (k) { f.setAttribute(k, attrs[k]); });
      f.srcdoc = src.textContent.split('<\\/script').join('</script');
      var hs = (w.getAttribute('data-tcb-loox-h') || '').split(',');
      function fit() {
        // alturas da referência na mesma faixa de largura (documento estático): iframe, contêiner e bloco do app
        var k = mobile() ? 1 : 0;
        var h = +hs[k];
        if (h > 0 && !/100%/.test(attrs.height || '')) { f.style.height = h + 'px'; f.setAttribute('height', h + 'px'); }
        // contêiner e bloco: alturas medidas na referência junto com o iframe
        var ch = (w.getAttribute('data-tcb-loox-ch') || '').split(',')[k];
        if (ch) w.style.height = ch + 'px';
        var b = w.closest('[data-tcb-loox-bh]'), bh = b && (b.getAttribute('data-tcb-loox-bh') || '').split(',')[k];
        if (bh) b.style.height = bh + 'px';
      }
      f.addEventListener('load', function () { fit(); setTimeout(fit, 400); setTimeout(fit, 1500); });
      f.addEventListener('tcb-loox-layout', fit);
      var wasM = mobile();
      window.addEventListener('resize', function () {
        // documento certo para a largura (o Loox da referência renderiza outro layout abaixo de 750 px)
        if (mobile() !== wasM) {
          wasM = mobile();
          var s2 = (wasM && w.querySelector('script.tcb-loox-doc-m')) || w.querySelector('script.tcb-loox-doc');
          f.srcdoc = s2.textContent.split('<\\/script').join('</script');
          fit();
        }
        setTimeout(fit, 150);
      });
      w.appendChild(f);
      fit();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();

/* Loox Video Slider (home): shadow DOM declarativo com a marcação renderizada da referência; trilho desliza como o
   Swiper em loop (deslocamento em onda fica com cada slide), o vídeo do slide ativo toca no "viewport" e, com
   auto-play, ao terminar passa para o próximo. Começa no slide 0, como a referência ao carregar. */
(function () {
  'use strict';
  function init(w) {
    var sr = w.shadowRoot;
    if (!sr || w.dataset.tcbLvsInit) return;
    w.dataset.tcbLvsInit = '1';
    // versão da referência para a faixa de largura: celular (< 750), larga (contêiner no limite, >= 1524) ou desktop
    var cw = document.documentElement.clientWidth;
    var tm = cw < 750 ? w.querySelector('template.tcb-lvs-m') : cw >= 1524 ? w.querySelector('template.tcb-lvs-w') : null;
    if (tm) sr.innerHTML = tm.innerHTML;
    var wrap = sr.querySelector('.swiper-wrapper'), vp = sr.querySelector('.viewport');
    if (!wrap || !vp) return;
    var vids = Array.prototype.slice.call(vp.querySelectorAll('video.video'));
    var filler = vp.querySelector('img.filler');
    var kids = function () { return Array.prototype.slice.call(wrap.children); };
    var first = kids()[0];
    var step = parseFloat(first.style.width) + parseFloat(first.style.marginRight || 0);
    var T = parseFloat((wrap.style.transform.match(/translate3d\((-?[\d.]+)px/) || [0, 0])[1]);
    var p = kids().findIndex(function (s) { return s.classList.contains('swiper-slide-active'); });
    var vis = kids().map(function (s, k) { return s.classList.contains('swiper-slide-visible') ? k - p : null; }).filter(function (x) { return x !== null; });
    var lo = Math.min.apply(null, vis), hi = Math.max.apply(null, vis);
    function apply(anim) {
      wrap.style.transitionDuration = anim ? '300ms' : '0ms';
      wrap.style.transform = 'translate3d(' + T + 'px, 0px, 0px)';
      kids().forEach(function (s, k) {
        var d = k - p;
        s.classList.toggle('swiper-slide-visible', d >= lo && d <= hi);
        s.classList.toggle('swiper-slide-prev', d === -1);
        s.classList.toggle('swiper-slide-active', d === 0);
        s.classList.toggle('swiper-slide-next', d === 1);
        s.style.opacity = (d >= lo && d <= hi) ? '1' : '0';
      });
      vp.style.transform = kids()[p].style.transform;
    }
    function play() {
      var i = +kids()[p].getAttribute('data-swiper-slide-index');
      vids.forEach(function (v, k) { if (k !== i) { v.pause(); v.style.display = 'none'; } });
      var v = vids[i]; if (!v) return;
      v.style.display = ''; v.muted = true;
      if (filler && v.poster) filler.src = v.poster;
      try { v.currentTime = 0; } catch (e) {}
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    function go(dir, anim) {
      // loop: mantém margem de slides dos dois lados (como o Swiper reordena os clones)
      if (dir > 0 && p + hi + 2 >= kids().length) { wrap.appendChild(wrap.firstElementChild); p -= 1; T += step; apply(false); }
      if (dir < 0 && p + lo - 2 < 0) { wrap.insertBefore(wrap.lastElementChild, wrap.firstElementChild); p += 1; T -= step; apply(false); }
      p += dir; T -= dir * step;
      if (anim) void wrap.offsetWidth;
      apply(anim);
    }
    go(-1, false);  // estado ao carregar na referência: slide 0 ativo
    var nb = sr.querySelector('.next-slide-button'), pb = sr.querySelector('.previous-slide-button');
    if (nb) nb.addEventListener('click', function () { go(1, true); play(); });
    if (pb) pb.addEventListener('click', function () { go(-1, true); play(); });
    if (w.hasAttribute('auto-play')) vids.forEach(function (v) { v.addEventListener('ended', function () { go(1, true); play(); }); });
    var started = false;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      if (!started && es.some(function (e) { return e.isIntersecting; })) { started = true; play(); }
    }, { rootMargin: '200px 0px' }) : null;
    if (io) io.observe(w); else play();
  }
  function run() { document.querySelectorAll('loox-video-slider-widget[data-tcb-lvs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ParcelPanel (página Track your order): abas "Order Number" / "Tracking Number" como o app; o envio leva ao rastreio
   real desta loja (17TRACK), já que o app da referência não roda aqui. */
(function () {
  'use strict';
  function init(app) {
    if (app.dataset.tcbTrackInit) return; app.dataset.tcbTrackInit = '1';
    var tabs = app.querySelectorAll('.pp_tracking_tab [role=tab]');
    var forms = app.querySelectorAll('.pp_tracking_form_in > div > div');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.classList.toggle('pp_active', k === i); x.setAttribute('aria-selected', k === i ? 'true' : 'false'); x.setAttribute('tabindex', k === i ? '0' : '-1'); });
        app.querySelectorAll('.pp_tracking_form_desktop > div, .pp_tracking_form_mobile > div').forEach(function (f) {
          var isNums = /nums/.test(f.className);
          f.style.display = (i === 1) === isNums ? '' : 'none';
        });
      });
    });
    app.addEventListener('submit', function (e) {
      var f = e.target.closest('form'); if (!f) return;
      e.preventDefault();
      var q = new URLSearchParams({ lang: 'en' });
      var order = f.querySelector('[name=order]'), email = f.querySelector('[name=email]'), nums = f.querySelector('[name=nums], [name=tracking], input:not([name=order]):not([name=email])');
      if (order && order.value.trim()) { q.set('order', order.value.trim()); if (email && email.value.trim()) q.set('email', email.value.trim()); }
      else if (nums && nums.value.trim()) q.set('nums', nums.value.trim());
      location.href = '/apps/17TRACK?' + q.toString();
    });
  }
  function run() { document.querySelectorAll('[data-tcb-track]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
